import RedactionPageGroupContainer from './RedactionPageGroupContainer';

export default RedactionPageGroupContainer;